import { createContext } from "react";
import { i18n, TFunction } from "i18next";

export interface I18n extends Partial<i18n> {
  t: TFunction;
}

export class Identity18n implements I18n {
  public t: TFunction = (
    key: string,
    defaultValue?: string,
    args?: {}
  ): string => {
    if (!defaultValue) {
      throw new Error("default value not provided");
    }

    if (args) {
      for (const key in args) {
        defaultValue = defaultValue.replace(`{{${key}}}`, args[key]);
      }
    }

    return defaultValue;
  };
}

export const identity18n = new Identity18n();
export const i18nContext = createContext(identity18n);
